export default __webpack_public_path__ + "static/media/q5.4672fcc0.png";